export function setupState() {
	/* #### Simple State Machine #### */
	window.portal = {};
	window.portal.session = { authenticated: false, token: '', };
	window.portal.current_event_id = 0
	window.portal.user = {
		loaded: '',
		edit_mode: '',
		id: '',
		first_name: '',
		last_name: '',
		email: '',
		phone: '',
		address: '',
		address2: '',
		city: '',
		state: '',
		zip: '',
		country: '',
		image: '',
		address_confirmed: false,
	};
	window.portal.clearUser = () => { Object.keys(window.portal.user).forEach(v => window.portal.user[v] = ''); window.portal.clearCreds(); };
	window.portal.creds = {
		loaded: false,
		credentials: [],
		transfer: [],
		transfer_message: '',
	};
	window.portal.clearCreds = () => { window.portal.creds.loaded = false; window.portal.creds.credentials = []; window.portal.creds.transfer = []; };
	window.portal.orders = {
		loaded: false,
		orders: [],
	};
	window.portal.clearOrders = () => { window.portal.orders.loaded = false; window.portal.orders.orders = []; };
	// window.portal.claims = { loaded: false, enabled: false, };
	window.portal.clearClaims = () => { window.portal.claims.loaded = false; window.portal.claims.enabled = false; };
	window.portal.welcome = { loaded: false, enabled: false, ticket_selected: 0, lodging_selected: 0, load: '', reload: '' };

}